
const rooftopWaterproofingWorkerService = {
  title: "Rooftop Waterproofing Worker",
  icon: "🛡️",
  shortDescription:
    "Roof waterproofing patch work, leakage assessment, and terrace protection support.",
  longDescription:
    "Book waterproofing support for terrace leakage assessment, minor patch jobs, and area-level protection planning.",
  consultationNote:
    "Area-based waterproofing systems and full terrace treatment usually require inspection first.",
  responsePromise:
    "Assignment depends on roof condition, weather context, and local technician availability.",
  warrantyPolicy:
    "Support depends on treatment type, weather exposure, and surface condition.",
  subServices: [
    {
      id: "roof-leak-inspection",
      title: "Roof Leakage Inspection",
      icon: "💧",
      group: "Inspection",
      description:
        "Inspect terrace leakage, seepage signs, or likely roof damage entry points.",
      basePrice: 399,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "waterproof-patch-job",
      title: "Minor Waterproof Patch Job",
      icon: "🪣",
      group: "Repair",
      description:
        "Small-area waterproofing correction or patch where treatment is feasible.",
      basePrice: 999,
      priceType: "starts_at",
      duration: "1-3 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "terrace-treatment-estimate",
      title: "Terrace Treatment Estimate Visit",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection for broader terrace waterproofing estimate and solution planning.",
      basePrice: 499,
      priceType: "inspection",
      duration: "30-60 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default rooftopWaterproofingWorkerService;